var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.12in",
    height: "2.12in",
    viewBox: "0 0 53.848 53.848",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#252525",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.376 16.227h23.449l-1.357 9.9612h-1.0106l0.05774-1.0683c0-5.2549-1.7131-7.8823-5.1394-7.8823l-2.5119 17.8-2.512 17.8h2.7718l-0.11546 1.0106h-12.791l0.1732-1.0106h2.6274l5.0239-35.6c-3.5995 0.21173-6.1211 3.2145-7.5647 9.0084h-2.5152z",
    strokeWidth: 2.3368
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.2775-1.7e-6h11.953l-0.14442 1.0106h-2.1077l-2.1366 15.216h5.7457l2.1077-15.216h-1.9922l0.11546-1.0106h11.809l-0.11546 1.0106h-2.5408l-5.0239 35.6h2.5408l-0.11546 1.0106h-11.809l0.11546-1.0106h1.9922l2.714-19.345h-5.7168l-2.7141 19.345h2.1077l-0.11546 1.0106h-11.925l0.11549-1.0106h2.5408l5.0239-35.6h-2.5408z",
    strokeWidth: 2.3368
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.15dc1516d56383193858866933723360.svg";
export { ForwardRef as ReactComponent };